import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { AppShell } from "../components/AppShell";
import { parseStoreEntry } from "../domain/storeIdentity";

export function HomePage() {
  const [storeCode, setStoreCode] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const submit = (event: FormEvent) => {
    event.preventDefault();
    const parsed = parseStoreEntry(storeCode);
    if (!parsed) {
      setError("Enter your eight-digit OpsTrack location ID or existing five-digit store number / CFA code.");
      return;
    }
    navigate(`/store/${encodeURIComponent(parsed)}`);
  };
  return (
    <AppShell title="Boil-outs, clearly tracked." subtitle="Open a store dashboard to review fryer status and record operational work.">
      <section className="hero-grid">
        <div className="hero-panel">
          <p className="eyebrow">Store access</p>
          <h2>Open your dashboard</h2>
          <form className="inline-form" onSubmit={submit}>
            <label>Location ID or existing store code<input value={storeCode} onChange={(event) => { setStoreCode(event.target.value); setError(""); }} placeholder="e.g. 10000001 or CFA12345" maxLength={8} required aria-describedby="location-entry-help" aria-invalid={Boolean(error)} /></label>
            <button className="button primary" type="submit">Continue</button>
          </form>
          <p id="location-entry-help">Use the location ID supplied by OpsTrack. Existing five-digit store numbers still work.</p>
          {error && <p role="alert">{error}</p>}
        </div>
        <div className="metric-panel">
          <span>One operational view</span>
          <strong>Operational · Needed · Overdue</strong>
          <p>Realtime Firestore data, auditable history, and configurable leadership notifications.</p>
        </div>
      </section>
    </AppShell>
  );
}
